import React from 'react'
import './HowItWorks.css'

function HowItWorks() {
  const steps = [
    {
      number: '1',
      title: 'Define Requirements',
      description: 'Write your development goals in simple markdown. Be as specific or high-level as you want.'
    },
    {
      number: '2',
      title: 'Choose Your IDE',
      description: 'Select Cursor, VS Code, or Windsurf. AllNightAI integrates seamlessly with your workflow.'
    },
    {
      number: '3',
      title: 'Enable Auto Mode',
      description: 'Turn on autonomous mode and let AI take over. Set limits or let it run continuously.'
    },
    {
      number: '4',
      title: 'Wake Up to Results',
      description: 'Return to find features implemented, tests passing, and code committed. Review and merge when ready.'
    }
  ]

  return (
    <section className="how-it-works">
      <div className="container">
        <div className="how-it-works-header">
          <h2 className="how-it-works-title">
            How <span className="gradient-text">AllNightAI</span> works
          </h2>
          <p className="how-it-works-subtitle">
            Get started in minutes and let AI handle the rest
          </p>
        </div>
        <div className="steps">
          {steps.map((step, index) => (
            <div key={index} className="step">
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="step-connector"></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HowItWorks
